import Trie from '../utils/Trie';

const table = {
  ア: 'ア', ｱ: 'ア', イ: 'イ', ｲ: 'イ', ウ: 'ウ', ｳ: 'ウ', エ: 'エ', ｴ: 'エ', オ: 'オ', ｵ: 'オ',
  カ: 'カ', ｶ: 'カ', キ: 'キ', ｷ: 'キ', ク: 'ク', ｸ: 'ク', ケ: 'ケ', ｹ: 'ケ', コ: 'コ', ｺ: 'コ',
  'キ％': 'キ', 'キ%': 'キ', 'ｷ％': 'キ', 'ｷ%': 'キ', 'ク％': 'ク', 'ク%': 'ク', 'ｸ％': 'ク', 'ｸ%': 'ク',
  サ: 'サ', ｻ: 'サ', シ: 'シ', ｼ: 'シ', ス: 'ス', ｽ: 'ス', セ: 'セ', ｾ: 'セ', ソ: 'ソ', ｿ: 'ソ',
  'シ％': 'シ', 'シ%': 'シ', 'ｼ％': 'シ', 'ｼ%': 'シ', 'ス％': 'ス', 'ス%': 'ス', 'ｽ％': 'ス', 'ｽ%': 'ス',
  スィ: 'スィ', スｨ: 'スィ', ｽィ: 'スィ', ｽｨ: 'スィ',
  タ: 'タ', ﾀ: 'タ', チ: 'チ', ﾁ: 'チ', ツ: 'ツ', ﾂ: 'ツ', テ: 'テ', ﾃ: 'テ', ト: 'ト', ﾄ: 'ト',
  'チ％': 'チ', 'チ%': 'チ', 'ﾁ％': 'チ', 'ﾁ%': 'チ', 'ツ％': 'ツ', 'ツ%': 'ツ', 'ﾂ％': 'ツ', 'ﾂ%': 'ツ',
  ティ: 'ティ', テｨ: 'ティ', ﾃィ: 'ティ', ﾃｨ: 'ティ', トゥ: 'トゥ', トｩ: 'トゥ', ﾄゥ: 'トゥ', ﾄｩ: 'トゥ',
  ナ: 'ナ', ﾅ: 'ナ', ニ: 'ニ', ﾆ: 'ニ', ヌ: 'ヌ', ﾇ: 'ヌ', ネ: 'ネ', ﾈ: 'ネ', ノ: 'ノ', ﾉ: 'ノ',
  ハ: 'ハ', ﾊ: 'ハ', ヒ: 'ヒ', ﾋ: 'ヒ', フ: 'フ', ﾌ: 'フ', ヘ: 'ヘ', ﾍ: 'ヘ', ホ: 'ホ', ﾎ: 'ホ',
  'ヒ%': 'ヒ', 'ヒ％': 'ヒ', 'ﾋ％': 'ヒ', 'ﾋ%': 'ヒ', 'フ％': 'フ', 'フ%': 'フ', 'ﾌ％': 'フ', 'ﾌ%': 'フ',
  マ: 'マ', ﾏ: 'マ', ミ: 'ミ', ﾐ: 'ミ', ム: 'ム', ﾑ: 'ム', メ: 'メ', ﾒ: 'メ', モ: 'モ', ﾓ: 'モ',
  ラ: 'ラ', ﾗ: 'ラ', リ: 'リ', ﾘ: 'リ', ル: 'ル', ﾙ: 'ル', レ: 'レ', ﾚ: 'レ', ロ: 'ロ', ﾛ: 'ロ',
  ガ: 'ガ', ｶﾞ: 'ガ', ギ: 'ギ', ｷﾞ: 'ギ', グ: 'グ', ｸﾞ: 'グ', ゲ: 'ゲ', ｹﾞ: 'ゲ', ゴ: 'ゴ', ｺﾞ: 'ゴ',
  カ゚: 'ガ', ｶﾟ: 'ガ', キ゚: 'ギ', ｷﾟ: 'ギ', ク゚: 'グ', ｸﾟ: 'グ', ケ゚: 'ゲ', ｹﾟ: 'ゲ', コ゚: 'ゴ', ｺﾟ: 'ゴ',
  ザ: 'ザ', ｻﾞ: 'ザ', ジ: 'ジ', ｼﾞ: 'ジ', ズ: 'ズ', ｽﾞ: 'ズ', ゼ: 'ゼ', ｾﾞ: 'ゼ', ゾ: 'ゾ', ｿﾞ: 'ゾ',
  ズィ: 'ズィ', ズｨ: 'ズィ', ｽﾞィ: 'ズィ', ｽﾞｨ: 'ズィ',
  ダ: 'ダ', ﾀﾞ: 'ダ', ディ: 'ディ', デｨ: 'ディ', ﾃﾞｨ: 'ディ', ﾃﾞィ: 'ディ',
  ドゥ: 'ドゥ', ドｩ: 'ドゥ', ﾄﾞゥ: 'ドゥ', ﾄﾞｩ: 'ドゥ', デ: 'デ',  ﾃﾞ: 'デ', ド: 'ド', ﾄﾞ: 'ド',
  バ: 'バ', ﾊﾞ: 'バ', ビ: 'ビ', ﾋﾞ: 'ビ', ブ: 'ブ', ﾌﾞ: 'ブ', ベ: 'ベ', ﾍﾞ: 'ベ', ボ: 'ボ', ﾎﾞ: 'ボ',

  ヴァ: 'ヴァ', ヴｧ: 'ヴァ', ヴィ: 'ヴィ', ヴｨ: 'ヴィ', ヴ: 'ヴ', ヴェ: 'ヴェ', ヴｪ: 'ヴェ', ヴォ: 'ヴォ', ヴｫ: 'ヴォ',
  ｳﾞァ: 'ヴァ', ｳﾞｧ: 'ヴァ', ｳﾞィ: 'ヴィ', ｳﾞｨ: 'ヴィ', ｳﾞ: 'ヴ', ｳﾞェ: 'ヴェ', ｳﾞｪ: 'ヴェ', ｳﾞォ: 'ヴォ', ｳﾞｫ: 'ヴォ',
  パ: 'パ', ﾊﾟ: 'パ', ピ: 'ピ', ﾋﾟ: 'ピ', プ: 'プ', ﾌﾟ: 'プ', ペ: 'ペ', ﾍﾟ: 'ペ', ポ: 'ポ', ﾎﾟ: 'ポ',
  'ピ％': 'ピ', 'ピ%': 'ピ', 'ﾋﾟ％': 'ピ', 'ﾋﾟ%': 'ピ', 'プ％': 'プ', 'プ%': 'プ', 'ﾌﾟ%': 'プ', 'ﾌﾟ％': 'プ',
  ヤ: 'ヤ', ﾔ: 'ヤ', ユ: 'ユ', ﾕ: 'ユ', イェ: 'イェ', イｪ: 'イェ', ｲェ: 'イェ', ｲｪ: 'イェ', ヨ: 'ヨ', ﾖ: 'ヨ',
  キャ: 'キャ', キｬ: 'キャ', ｷャ: 'キャ', ｷｬ: 'キャ', キュ: 'キュ', キｭ: 'キュ', ｷュ: 'キュ', ｷｭ: 'キュ',
  キェ: 'キェ', キｪ: 'キェ', ｷェ: 'キェ', ｷｪ: 'キェ', キョ: 'キョ', キｮ: 'キョ', ｷョ: 'キョ', ｷｮ: 'キョ',
  'キュ％': 'キュ', 'キュ%': 'キュ', 'キｭ％': 'キュ', 'キｭ%': 'キュ',
  'ｷュ％': 'キュ', 'ｷュ%': 'キュ', 'ｷｭ％': 'キュ', 'ｷｭ%': 'キュ',
  シャ: 'シャ', シｬ: 'シャ', ｼャ: 'シャ', ｼｬ: 'シャ', シュ: 'シュ', シｭ: 'シュ', ｼュ: 'シュ', ｼｭ: 'シュ',
  シェ: 'シェ', シｪ: 'シェ', ｼェ: 'シェ', ｼｪ: 'シェ', ショ: 'ショ', シｮ: 'ショ', ｼョ: 'ショ', ｼｮ: 'ショ',
  'シュ％': 'シュ', 'シュ%': 'シュ', 'シｭ％': 'シュ', 'シｭ%': 'シュ',
  'ｼュ％': 'シュ', 'ｼュ%': 'シュ', 'ｼｭ％': 'シュ', 'ｼｭ%': 'シュ',
  チャ: 'チャ', チｬ: 'チャ', ﾁャ: 'チャ', ﾁｬ: 'チャ', チュ: 'チュ', チｭ: 'チュ', ﾁュ: 'チュ', ﾁｭ: 'チュ',
  チェ: 'チェ', チｪ: 'チェ', ﾁェ: 'チェ', ﾁｪ: 'チェ', チョ: 'チョ', チｮ: 'チョ', ﾁョ: 'チョ', ﾁｮ: 'チョ',
  'チュ％': 'チュ', 'チュ%': 'チュ', 'チｭ％': 'チュ', 'チｭ%': 'チュ',
  'ﾁュ％': 'チュ', 'ﾁュ%': 'チュ', 'ﾁｭ％': 'チュ', 'ﾁｭ%': 'チュ',
  テャ: 'テャ', テｬ: 'テャ', ﾃャ: 'テャ', ﾃｬ: 'テャ', テュ: 'テュ', テｭ: 'テュ', ﾃュ: 'テュ', ﾃｭ: 'テュ',
  ティェ: 'ティェ', ティｪ: 'ティェ', テｨェ: 'ティェ', テｨｪ: 'ティェ',
  ﾃィェ: 'ティェ', ﾃィｪ: 'ティェ', ﾃｨェ: 'ティェ', ﾃｨｪ: 'ティェ',
  テョ: 'テョ', テｮ: 'テョ', ﾃョ: 'テョ', ﾃｮ: 'テョ',
  ニャ: 'ニャ', ニｬ: 'ニャ', ﾆャ: 'ニャ', ﾆｬ: 'ニャ', ニュ: 'ニュ', ニｭ: 'ニュ', ﾆュ: 'ニュ', ﾆｭ: 'ニュ',
  ニェ: 'ニェ', ニｪ: 'ニェ', ﾆェ: 'ニェ', ﾆｪ: 'ニェ', ニョ: 'ニョ', ニｮ: 'ニョ', ﾆョ: 'ニョ', ﾆｮ: 'ニョ',
  ヒャ: 'ヒャ', ヒｬ: 'ヒャ', ﾋャ: 'ヒャ', ﾋｬ: 'ヒャ', ヒュ: 'ヒュ', ヒｭ: 'ヒュ', ﾋュ: 'ヒュ', ﾋｭ: 'ヒュ',
  ヒェ: 'ヒェ', ヒｪ: 'ヒェ', ﾋェ: 'ヒェ', ﾋｪ: 'ヒェ', ヒョ: 'ヒョ', ヒｮ: 'ヒョ', ﾋョ: 'ヒョ', ﾋｮ: 'ヒョ',
  'ヒュ％': 'ヒュ', 'ヒュ%': 'ヒュ', 'ヒｭ％': 'ヒュ', 'ヒｭ%': 'ヒュ',
  'ﾋュ％': 'ヒュ', 'ﾋュ%': 'ヒュ', 'ﾋｭ％': 'ヒュ', 'ﾋｭ%': 'ヒュ',
  フャ: 'フャ', フｬ: 'フャ', ﾌャ: 'フャ', ﾌｬ: 'フャ', フュ: 'フュ', フｭ: 'フュ', ﾌュ: 'フュ', ﾌｭ: 'フュ',
  フィェ: 'フィェ', フィｪ: 'フィェ', フｨェ: 'フィェ', フｨｪ: 'フィェ', ﾌィェ: 'フィェ', ﾌィｪ: 'フィェ', ﾌｨェ: 'フィェ', ﾌｨｪ: 'フィェ',
  フョ: 'フョ', フｮ: 'フョ', ﾌョ: 'フョ', ﾌｮ: 'フョ',
  ミャ: 'ミャ', ミｬ: 'ミャ', ﾐャ: 'ミャ', ﾐｬ: 'ミャ', ミュ: 'ミュ', ミｭ: 'ミュ', ﾐュ: 'ミュ', ﾐｭ: 'ミュ',
  ミェ: 'ミェ', ミｪ: 'ミェ', ﾐェ: 'ミェ', ﾐｪ: 'ミェ', ミョ: 'ミョ', ミｮ: 'ミョ', ﾐョ: 'ミョ', ﾐｮ: 'ミョ',
  リャ: 'リャ', リｬ: 'リャ', ﾘャ: 'リャ', ﾘｬ: 'リャ', リュ: 'リュ', リｭ: 'リュ', ﾘュ: 'リュ', ﾘｭ: 'リュ',
  リェ: 'リェ', リｪ: 'リェ', ﾘェ: 'リェ', ﾘｪ: 'リェ', リョ: 'リョ', リｮ: 'リョ', ﾘョ: 'リョ', ﾘｮ: 'リョ',
  ギャ: 'ギャ', ギｬ: 'ギャ', ｷﾞャ: 'ギャ', ｷﾞｬ: 'ギャ', ギュ: 'ギュ', ギｭ: 'ギュ', ｷﾞュ: 'ギュ', ｷﾞｭ: 'ギュ',
  ギェ: 'ギェ', ギｪ: 'ギェ', ｷﾞェ: 'ギェ', ｷﾞｪ: 'ギェ', ギョ: 'ギョ', ギｮ: 'ギョ', ｷﾞョ: 'ギョ', ｷﾞｮ: 'ギョ',
  キ゚ャ: 'ギャ', キ゚ｬ: 'ギャ', ｷﾟャ: 'ギャ', ｷﾟｬ: 'ギャ', キ゚ュ: 'ギュ', キ゚ｭ: 'ギュ', ｷﾟュ: 'ギュ', ｷﾟｭ: 'ギュ',
  キ゚ェ: 'ギェ', キ゚ｪ: 'ギェ', ｷﾟェ: 'ギェ', ｷﾟｪ: 'ギェ', キ゚ョ: 'ギョ', キ゚ｮ: 'ギョ', ｷﾟョ: 'ギョ', ｷﾟｮ: 'ギョ',
  ジャ: 'ジャ', ジｬ: 'ジャ', ｼﾞャ: 'ジャ', ｼﾞｬ: 'ジャ', ジュ: 'ジュ', ジｭ: 'ジュ', ｼﾞュ: 'ジュ', ｼﾞｭ: 'ジュ',
  ジェ: 'ジェ', ジｪ: 'ジェ', ｼﾞェ: 'ジェ', ｼﾞｪ: 'ジェ', ジョ: 'ジョ', ジｮ: 'ジョ', ｼﾞョ: 'ジョ', ｼﾞｮ: 'ジョ',
  デャ: 'デャ', デｬ: 'デャ', ﾃﾞｬ: 'デャ', ﾃﾞャ: 'デャ', デュ: 'デュ', デｭ: 'デュ', ﾃﾞｭ: 'デュ', ﾃﾞュ: 'デュ',
  ディェ: 'ディェ', ディｪ: 'ディェ', デｨェ: 'ディェ', デｨｪ: 'ディェ',
  ﾃﾞィェ: 'ディェ', ﾃﾞィｪ: 'ディェ', ﾃﾞｨェ: 'ディェ', ﾃﾞｨｪ: 'ディェ',
  デョ: 'デョ', デｮ: 'デョ', ﾃﾞｮ: 'デョ', ﾃﾞョ: 'デョ',
  ビャ: 'ビャ', ビｬ: 'ビャ', ﾋﾞャ: 'ビャ', ﾋﾞｬ: 'ビャ', ビュ: 'ビュ', ビｭ: 'ビュ', ﾋﾞュ: 'ビュ', ﾋﾞｭ: 'ビュ',
  ビェ: 'ビェ', ビｪ: 'ビェ', ﾋﾞェ: 'ビェ', ﾋﾞｪ: 'ビェ', ビョ: 'ビョ', ビｮ: 'ビョ', ﾋﾞョ: 'ビョ', ﾋﾞｮ: 'ビョ',
  ヴャ: 'ヴャ', ヴｬ: 'ヴャ', ｳﾞャ: 'ヴャ', ｳﾞｬ: 'ヴャ', ヴュ: 'ヴュ', ヴｭ: 'ヴュ', ｳﾞュ: 'ヴュ', ｳﾞｭ: 'ヴュ',
  ヴィェ: 'ヴィェ', ヴィｪ: 'ヴィェ', ヴｨェ: 'ヴィェ', ヴｨｪ: 'ヴィェ',
  ｳﾞィェ: 'ヴィェ', ｳﾞィｪ: 'ヴィェ', ｳﾞｨェ: 'ヴィェ', ｳﾞｨｪ: 'ヴィェ',
  ヴョ: 'ヴョ', ヴｮ: 'ヴョ', ｳﾞョ: 'ヴョ', ｳﾞｮ: 'ヴョ',
  ピャ: 'ピャ', ピｬ: 'ピャ', ﾋﾟャ: 'ピャ', ﾋﾟｬ: 'ピャ', ピュ: 'ピュ', ピｭ: 'ピュ', ﾋﾟュ: 'ピュ', ﾋﾟｭ: 'ピュ',
  ピェ: 'ピェ', ピｪ: 'ピェ', ﾋﾟェ: 'ピェ', ﾋﾟｪ: 'ピェ', ピョ: 'ピョ', ピｮ: 'ピョ', ﾋﾟョ: 'ピョ', ﾋﾟｮ: 'ピョ',
  'ピュ％': 'ピュ', 'ピュ%': 'ピュ', 'ピｭ％': 'ピュ', 'ピｭ%': 'ピュ',
  'ﾋﾟュ％': 'ピュ', 'ﾋﾟュ%': 'ピュ', 'ﾋﾟｭ％': 'ピュ', 'ﾋﾟｭ%': 'ピュ',

  ワ: 'ワ', ﾜ: 'ワ', ウィ: 'ウィ', ｳｨ: 'ウィ', ウェ: 'ウェ', ｳｪ: 'ウェ', ウォ: 'ウォ', ｳｫ: 'ウォ',
  クァ: 'クァ', クｧ: 'クァ', ｸァ: 'クァ', ｸｧ: 'クァ', クィ: 'クィ', クｨ: 'クィ', ｸィ: 'クィ', ｸｨ: 'クィ',
  クェ: 'クェ', クｪ: 'クェ', ｸェ: 'クェ', ｸｪ: 'クェ', クォ: 'クォ', クｫ: 'クォ', ｸォ: 'クォ', ｸｫ: 'クォ',
  スァ: 'スァ', スｧ: 'スァ', ｽァ: 'スァ', ｽｧ: 'スァ',
  スゥィ: 'スゥィ', スゥｨ: 'スゥィ', スｩィ: 'スゥィ', スｩｨ: 'スゥィ', ｽゥィ: 'スゥィ', ｽゥｨ: 'スゥィ', ｽｩィ: 'スゥィ', ｽｩｨ: 'スゥィ',
  スェ: 'スェ', スｪ: 'スェ', ｽェ: 'スェ', ｽｪ: 'スェ', スォ: 'スォ', スｫ: 'スォ', ｽォ: 'スォ', ｽｫ: 'スォ',
  ツァ: 'ツァ', ツｧ: 'ツァ', ﾂァ: 'ツァ', ﾂｧ: 'ツァ', ツィ: 'ツィ', ツｨ: 'ツィ', ﾂィ: 'ツィ', ﾂｨ: 'ツィ',
  ツェ: 'ツェ', ツｪ: 'ツェ', ﾂェ: 'ツェ', ﾂｪ: 'ツェ', ツォ: 'ツォ', ツｫ: 'ツォ', ﾂォ: 'ツォ', ﾂｫ: 'ツォ',
  トゥァ: 'トゥァ', トゥｧ: 'トゥァ', トｩァ: 'トゥァ', トｩｧ: 'トゥァ', ﾄゥァ: 'トゥァ', ﾄゥｧ: 'トゥァ', ﾄｩァ: 'トゥァ', ﾄｩｧ: 'トゥァ',
  トゥィ: 'トゥィ', トゥｨ: 'トゥィ', トｩィ: 'トゥィ', トｩｨ: 'トゥィ', ﾄゥィ: 'トゥィ', ﾄゥｨ: 'トゥィ', ﾄｩィ: 'トゥィ', ﾄｩｨ: 'トゥィ',
  トゥェ: 'トゥェ', トゥｪ: 'トゥェ', トｩェ: 'トゥェ', トｩｪ: 'トゥェ', ﾄゥェ: 'トゥェ', ﾄゥｪ: 'トゥェ', ﾄｩェ: 'トゥェ', ﾄｩｪ: 'トゥェ',
  トゥォ: 'トゥォ', トゥｫ: 'トゥォ', トｩォ: 'トゥォ', トｩｫ: 'トゥォ', ﾄゥォ: 'トゥォ', ﾄゥｫ: 'トゥォ', ﾄｩォ: 'トゥォ', ﾄｩｫ: 'トゥォ',
  ヌァ: 'ヌァ', ヌｧ: 'ヌァ', ﾇァ: 'ヌァ', ﾇｧ: 'ヌァ', ヌィ: 'ヌィ', ヌｨ: 'ヌィ', ﾇィ: 'ヌィ', ﾇｨ: 'ヌィ',
  ヌェ: 'ヌェ', ヌｪ: 'ヌェ', ﾇェ: 'ヌェ', ﾇｪ: 'ヌェ', ヌォ: 'ヌォ', ヌｫ: 'ヌォ', ﾇォ: 'ヌォ', ﾇｫ: 'ヌォ',
  ファ: 'ファ', フｧ: 'ファ', ﾌァ: 'ファ', ﾌｧ: 'ファ', フィ: 'フィ', フｨ: 'フィ', ﾌィ: 'フィ', ﾌｨ: 'フィ',
  フェ: 'フェ', フｪ: 'フェ', ﾌェ: 'フェ', ﾌｪ: 'フェ', フォ: 'フォ', フｫ: 'フォ', ﾌォ: 'フォ', ﾌｫ: 'フォ',
  ムァ: 'ムァ', ムｧ: 'ムァ', ﾑァ: 'ムァ', ﾑｧ: 'ムァ', ムィ: 'ムィ', ムｨ: 'ムィ', ﾑィ: 'ムィ', ﾑｨ: 'ムィ',
  ムェ: 'ムェ', ムｪ: 'ムェ', ﾑェ: 'ムェ', ﾑｪ: 'ムェ', ムォ: 'ムォ', ムｫ: 'ムォ', ﾑォ: 'ムォ', ﾑｫ: 'ムォ',
  ルァ: 'ルァ', ルｧ: 'ルァ', ﾙァ: 'ルァ', ﾙｧ: 'ルァ', ルィ: 'ルィ', ルｨ: 'ルィ', ﾙィ: 'ルィ', ﾙｨ: 'ルィ',
  ルェ: 'ルェ', ルｪ: 'ルェ', ﾙェ: 'ルェ', ﾙｪ: 'ルェ', ルォ: 'ルォ', ルｫ: 'ルォ', ﾙォ: 'ルォ', ﾙｫ: 'ルォ',
  グァ: 'グァ', グｧ: 'グァ', ｸﾞァ: 'グァ', ｸﾞｧ: 'グァ', グィ: 'グィ', グｨ: 'グィ', ｸﾞィ: 'グィ', ｸﾞｨ: 'グィ',
  グェ: 'グェ', グｪ: 'グェ', ｸﾞェ: 'グェ', ｸﾞｪ: 'グェ', グォ: 'グォ', グｫ: 'グォ', ｸﾞォ: 'グォ', ｸﾞｫ: 'グォ',
  ク゚ァ: 'グァ', ク゚ｧ: 'グァ', ｸﾟァ: 'グァ', ｸﾟｧ: 'グァ', ク゚ィ: 'グィ', ク゚ｨ: 'グィ', ｸﾟィ: 'グィ', ｸﾟｨ: 'グィ',
  ク゚ェ: 'グェ', ク゚ｪ: 'グェ', ｸﾟェ: 'グェ', ｸﾟｪ: 'グェ', ク゚ォ: 'グォ', ク゚ｫ: 'グォ', ｸﾟォ: 'グォ', ｸﾟｫ: 'グォ',
  ズァ: 'ズァ', ズｧ: 'ズァ', ｽﾞｧ: 'ズァ', ｽﾞァ: 'ズァ',
  ズゥィ: 'ズゥィ', ズゥｨ: 'ズゥィ', ズｩィ: 'ズゥィ', ズｩｨ: 'ズゥィ',
  ｽﾞゥィ: 'ズゥィ', ｽﾞゥｨ: 'ズゥィ', ｽﾞｩィ: 'ズゥィ', ｽﾞｩｨ: 'ズゥィ',
  ズェ: 'ズェ', ズｪ: 'ズェ', ｽﾞｪ: 'ズェ', ｽﾞェ: 'ズェ', ズォ: 'ズォ', ズｫ: 'ズォ', ｽﾞｫ: 'ズォ', ｽﾞォ: 'ズォ',
  ドゥァ: 'ドゥァ', ドゥｧ: 'ドゥァ', ドｩァ: 'ドゥァ', ドｩｧ: 'ドゥァ',
  ﾄﾞゥァ: 'ドゥァ', ﾄﾞゥｧ: 'ドゥァ', ﾄﾞｩァ: 'ドゥァ', ﾄﾞｩｧ: 'ドゥァ',
  ドゥィ: 'ドゥィ', ドゥｨ: 'ドゥィ', ドｩィ: 'ドゥィ', ドｩｨ: 'ドゥィ',
  ﾄﾞゥィ: 'ドゥィ', ﾄﾞゥｨ: 'ドゥィ', ﾄﾞｩィ: 'ドゥィ', ﾄﾞｩｨ: 'ドゥィ',
  ドゥェ: 'ドゥェ', ドゥｪ: 'ドゥェ', ドｩェ: 'ドゥェ', ドｩｪ: 'ドゥェ',
  ﾄﾞゥェ: 'ドゥェ', ﾄﾞゥｪ: 'ドゥェ', ﾄﾞｩェ: 'ドゥェ', ﾄﾞｩｪ: 'ドゥェ',
  ドゥォ: 'ドゥォ', ドゥｫ: 'ドゥォ', ドｩォ: 'ドゥォ', ドｩｫ: 'ドゥォ',
  ﾄﾞゥォ: 'ドゥォ', ﾄﾞゥｫ: 'ドゥォ', ﾄﾞｩォ: 'ドゥォ', ﾄﾞｩｫ: 'ドゥォ',
  ブァ: 'ブァ', ブｧ: 'ブァ', ﾌﾞｧ: 'ブァ', ﾌﾞァ: 'ブァ', ブィ: 'ブィ', ブｨ: 'ブィ', ﾌﾞｨ: 'ブィ', ﾌﾞィ: 'ブィ',
  ブェ: 'ブェ', ブｪ: 'ブェ', ﾌﾞｪ: 'ブェ', ﾌﾞェ: 'ブェ', ブォ: 'ブォ', ブｫ: 'ブォ', ﾌﾞｫ: 'ブォ', ﾌﾞォ: 'ブォ',
  ヴゥァ: 'ヴゥァ', ヴゥｧ: 'ヴゥァ', ヴｩァ: 'ヴゥァ', ヴｩｧ: 'ヴゥァ',
  ｳﾞゥァ: 'ヴゥァ', ｳﾞゥｧ: 'ヴゥァ', ｳﾞｩァ: 'ヴゥァ', ｳﾞｩｧ: 'ヴゥァ',
  ヴゥィ: 'ヴゥィ', ヴゥｨ: 'ヴゥィ', ヴｩィ: 'ヴゥィ', ヴｩｨ: 'ヴゥィ',
  ｳﾞゥィ: 'ヴゥィ', ｳﾞゥｨ: 'ヴゥィ', ｳﾞｩィ: 'ヴゥィ', ｳﾞｩｨ: 'ヴゥィ',
  ヴゥェ: 'ヴゥェ', ヴゥｪ: 'ヴゥェ', ヴｩェ: 'ヴゥェ', ヴｩｪ: 'ヴゥェ',
  ｳﾞゥェ: 'ヴゥェ', ｳﾞゥｪ: 'ヴゥェ', ｳﾞｩェ: 'ヴゥェ', ｳﾞｩｪ: 'ヴゥェ',
  ヴゥォ: 'ヴゥォ', ヴゥｫ: 'ヴゥォ', ヴｩォ: 'ヴゥォ', ヴｩｫ: 'ヴゥォ',
  ｳﾞゥォ: 'ヴゥォ', ｳﾞゥｫ: 'ヴゥォ', ｳﾞｩォ: 'ヴゥォ', ｳﾞｩｫ: 'ヴゥォ',
  プァ: 'プァ', プｧ: 'プァ', ﾌﾟｧ: 'プァ', ﾌﾟァ: 'プァ', プィ: 'プィ', プｨ: 'プィ', ﾌﾟｨ: 'プィ', ﾌﾟィ: 'プィ',
  プェ: 'プェ', プｪ: 'プェ', ﾌﾟｪ: 'プェ', ﾌﾟェ: 'プェ', プォ: 'プォ', プｫ: 'プォ', ﾌﾟｫ: 'プォ', ﾌﾟォ: 'プォ',

  ッ: 'ッ', ｯ: 'ッ', ン: 'ン', ﾝ: 'ン', ー: 'ー', ｰ: 'ー',

  '’': '', '\'': '', '’０': '', '\'０': '', '’0': '', '\'0': '',
  '’１': '', '\'１': '', '’1': '', '\'1': '', '’２': '', '\'２': '', '’2': '', '\'2': '',
  0: '', '０': '',

  '／': ' ', '/': ' ', '｜': ' ', '|': ' ', '．': '。', '.': '。', '？': '？', '?': '？',
  '＿': '(', _: '(', '＿０': '(', '＿0': '(', _０: '(', _0: '(',
  '＿１': '(', '＿1': '(', _１: '(', _1: '(', '＿２': '(', '＿2': '(', _２: '(', _2: '(',
};

export default new Trie(table);
